<template>
  <div class="viewDialog">
    <BaseDialog title="退费" :isshow="visible" @handleShow="(val) => {visible = val }" width="65%" height="auto">
      <div class="patentList fatherHeight contBox">
        <div class="momey-total" style="font-size: 16px;font-weight: bold;">
          <div class="item">姓名:{{info.name}}</div>
          <div class="item">日期:{{info.schedule_date}}</div>
          <div class="item">病例号:{{info.case_no}}</div>
          <div class="item item1">身份证号:{{info.cert_no}}</div>
        </div>

        <div class=" flex-end">
          <el-radio-group v-model="cfArrValue">
            <el-radio class="radio-bg" v-for="(item,index) in cfArr" :key="index" :label="item.id">
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </div>
        <div class="box-info">
          <table class="info-table" cellspacing="0">
            <tr>
              <td class="color-blue border-right">费用总金额</td>
              <td class="border-right">30</td>
              <td class="color-blue border-right">优惠金额</td>
              <td class="border-right">30</td>
              <td class="color-blue border-right">优惠后金额</td>
              <td>30</td>
            </tr>
            <tr>
              <td class="color-blue border-right">自费支付</td>
              <td class="border-right">30</td>
              <td class="color-blue border-right">医疗机构分担金额</td>
              <td class="border-right">30</td>
              <td class="color-blue border-right">个人自费项目金额</td>
              <td class="">30</td>
            </tr>
            <tr>
              <td class="color-blue border-right">个人自付金额</td>
              <td class="border-right">30</td>
              <td class="color-blue border-right">广州新api支付</td>
              <td class="border-right">30</td>
              <td class="color-blue border-right">报销支付</td>
              <td class="">30</td>
            </tr>
            <tr>
              <td class="color-blue border-right">超统筹支付限额个人自付金额</td>
              <td class="border-right">30</td>
              <td class="color-blue border-right">部分项目自费金额</td>
              <td class="border-right">30</td>
              <td class="color-blue border-right">先行自付金额</td>
              <td class="">30</td>
            </tr>
            <tr>
              <td class="color-blue border-right">实收</td>
              <td class="border-right ">30</td>
              <td class="color-blue border-right">自费原因</td>
              <td class="border-right">30</td>
              <td class="border-right"></td>
              <td class=""></td>
            </tr>
          </table>
          <div class="momey-total">
            <div class="item">退费类目:124444</div>
            <div class="item">退费金额:124444</div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="color-cancel" type="primary" @click="visible = false">
            取消
          </el-button>
          <el-button @click="savePatient" :loading="saveLoad" class="color-determine" type="primary">
            确定
          </el-button>
        </div>
      </template>
    </BaseDialog>
  </div>
</template>
<script setup name="tuiFei">
  import {
    reactive,
    toRefs,
    ref,
    nextTick,
    onMounted,
    onBeforeUnmount, defineEmits
  } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import service from '@/utils/request'
  import { gitDictList } from '@/utils/tool'
  import { ElMessageBox, ElMessage } from 'element-plus'
  import BaseDialog from '@/components/Dialog/index.vue'
  const emit = defineEmits(['refreshDataList'])
  const visible = ref(false)
  const saveLoad = ref(false)
  const cfArr = ref([
    { name: '现金退', id: 1 },
    { name: '原方式返回', id: 2 },
  ])
  const cfArrValue = ref([])
  async function savePatient() {
    if (cfArrValue.value == '' || cfArrValue.value == null || cfArrValue.value == undefined) {
      ElMessage.error('请选择退费方式');
    }
    console.log(cfArrValue.value)
    // saveLoad.value = true
    // let data = {
    //   ...info.value,
    //   pay_data: pay_data.value
    // }
    // let res = await service.post(
    //   '/api/medical/sub_settle_accounts',
    //   data
    // )
    // saveLoad.value = false
    // if (res.code === 0) {
    //   ElMessage.success(res.msg)
    // visible.value = false
    // emit('refreshDataList')
    // }
  }
  const info = ref({})
  const router = useRouter()
  const route = useRoute()
  const searchData = ref(
    {
      dict_dialysis_cycle: '',
      dict_dialysis_type: '',
      dict_hospital_area: '',
      b: []
    }
  )
  const formData = ref({})
  const tableData = ref([])
  const dictList = ref([])
  const searchForm = ref({})
  const statistic = ref('')
  const istable = ref(true)
  const tableBoxRef = ref(null)
  const tableHei = ref(0)

  onMounted(() => {
    istable.value = false
    // tableHei.value = tableBoxRef.value.clientHeight - 40
    nextTick(() => {
      istable.value = true
    })
    initData()
  })


  const initData = async () => {

    dictList.value = await gitDictList([
      '117000000',
      '210000000',
      '103000000',
      '323000000',
    ])
    dictList.value[323000000].forEach((item) => {
      item.active = false
    })
  }



  const getDataList = async () => {
    searchData.value.current = pageData.value.currentPage
    searchData.value.size = pageData.value.pageSize
    dataListLoading.value = true
    let res = await service.post(
      '/api/patient/get_patient_list',
      searchData.value
    )
    dataListLoading.value = false
    if (res.code === 0) {
      tableData.value = res.data.records
      pageData.value.totalSum = res.data.total
      statistic.value = '总金额:123  待结算金额:123 已退费金额:123 病人待结算金额:123'
    }
  }

  defineExpose({
    visible,
    info
  })
</script>
<style lang="scss">
  .el-notification__group {
    flex: 1;
  }

  .notice_but {
    text-align: right;
    color: #3167a8;
    cursor: pointer;
  }
</style>
<style scoped lang="scss">
  .demo-form-inline {
    margin-top: 0;
    //flex: 1;
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    grid-row-gap: 10px;
    //grid-template-rows: repeat(4, 40px);
    align-items: center;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .search-top .w-208 {
    width: 208px;
  }

  .table-tag {
    margin-right: 8px;
  }

  .fa-stack {
    width: 24px;
    height: 24px;
    cursor: pointer;
    float: right;

    .fa-stack-2x {
      font-size: 24px;
      color: rgba(49, 102, 174, 0.1);
    }

    .fa-stack-1x {
      font-size: 12px;
      color: #3166ae;
      line-height: 24px;
    }
  }

  .tagBox {
    display: flex;
    justify-content: flex-start;

    // margin-bottom: 10px;
    .tit {
      width: 83px;
      font-size: 14px;
      font-family: 'Source Han Sans CN-Bold';
      font-weight: bold;
      color: #666666;
    }

    .cont {
      width: calc(100% - 83px);
    }
  }

  .patientList {
    margin-top: 4px;
    height: calc(100% - 45px);
  }

  .list-top {
    .name {
      font-size: 18px;
      font-family: ' Source Han Sans CN-Medium';
      font-weight: 500;
      color: #000000;
      line-height: 32px;
    }
  }

  .patient-alert {
    background: rgba(49, 102, 174, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 18px;
    color: #3166ae;
    margin-top: 8px;
    padding: 4px 16px;

    .el-alert__icon {
      color: #3166ae;
    }

    &:deep(.el-alert__content) {
      position: relative;
      top: 3px;
    }
  }

  .table {
    margin-top: 10px;
    height: calc(100% - 82px);

    .img {
      width: 25px;
      height: 24px;
      margin-right: 14px;
    }
  }

  .searchBut {
    width: 100%;
    //margin-left: 20px;
    //margin-right: 29px;
    justify-self: right;
    display: flex;
    justify-content: end;
    margin-right: 28px;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .modify {
    background-color: #3166ae;
  }

  .bar-title {
    font-size: 18px;
    line-height: 18px;
    color: #000000;
    border-left: 6px solid #3166ae;
    padding: 0 18px;
    margin-bottom: 16px;
    font-weight: bold;
  }

  .momey-total {
    display: flex;
    margin: 10px;
    line-height: 30px;

    .item {
      margin-right: 20px;
      width: 150px;
    }
  }

  .radio-bg {
    background: rgba(49, 102, 174, 0.1);
    padding: 0px 10px;
    border-radius: 4px;
  }

  .info-table {
    width: 100%;
    margin: 10px 0;

    tr {
      height: 40px;
    }

    td {
      padding-left: 20px;
    }

    .color-blue {
      color: #3166ae;
      font-size: 14px;
      width: 230px;
    }

    .border-right {
      border-right: 1px solid gray;
    }

  }

  .info-table tr:nth-child(2n+1) {
    background-color: rgba(49, 102, 174, 0.1);
  }

  .item1 {
    width: 250px !important;
  }
</style>